var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 0C2.6865 0 0 2.6865 0 6C0 9.3135 2.6865 12 6 12C9.3135 12 12 9.3135 12 6C12 2.6865 9.3135 0 6 0ZM8.3535 5.3535C8.2555 5.4515 8.1275 5.5 7.9995 5.5H6.5V9C6.5 9.276 6.2765 9.5 6 9.5C5.7235 9.5 5.5 9.276 5.5 9V5.5H4.0005C3.8725 5.5 3.7445 5.4515 3.6465 5.3535C3.451 5.158 3.451 4.842 3.6465 4.6465L5.6465 2.6465C5.744 2.549 5.872 2.5 6 2.5C6.128 2.5 6.256 2.549 6.3535 2.6465L8.3535 4.6465C8.549 4.842 8.549 5.158 8.3535 5.3535Z",
    fill: "#2BDF68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceUp);
export default __webpack_public_path__ + "static/media/price_up.d6c23aa363f59bd78f3fe87d38e1b5f3.svg";
export { ForwardRef as ReactComponent };